module.exports = new __parcel__URL__("USDPLogo.d2d050af.svg").toString();